import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import type { AgentCall } from '../utils/agent-thread-state';
import style from '../style.module.scss';

/** What the agent understood for one call: a pulsing dot while it runs, a check once its card is in. */
export const ActivityLine: React.FC<{ call: AgentCall; running: boolean }> = ({
    call,
    running,
}) => (
    <li className={style.call} aria-busy={running}>
        {running ? (
            <span className={style.pulse} aria-hidden="true" />
        ) : (
            call.status === 'done' && (
                <CheckOutlined className={style.call_done} aria-hidden="true" />
            )
        )}
        <span>{call.summary}</span>
    </li>
);
